import { useMemo } from 'react';
import { useAIFeatureAvailability } from '../features/ai/useAIFeatureAvailability';
import {
  ADDONS,
  AFFILIATE,
  AI_ASSISTANTS,
  AI_CONFIGURATION_LABEL,
  BILLING,
  COMPANY,
  EMAIL_BATCHES,
  EMAILS_LABEL,
  HELP_CENTER,
  LOGOUT,
  MANAGE_USERS,
  OTHERS_LABEL,
  PERSONALIZATION,
  PROFILE,
  QUICK_VIDEOS,
  RECENTLY_DELETED,
  SCHEDULES,
  SOCIAL_PROFILES,
  TELEPROMPTER,
  VIDEO_ATTRIBUTES,
  VIDEO_EXPIRATION,
  VIDEO_LABEL,
} from './constants';

export const useAdminUserItems = () => {
  const {
    isPersonalizationAvailable,
    isAIAssistantsAvailable,
    isAIConfigurationAvailable,
    isQuickVideosAvailable,
  } = useAIFeatureAvailability();

  const items = useMemo(() => {
    const AI_ITEMS = [
      ...(isAIConfigurationAvailable ? [AI_CONFIGURATION_LABEL] : []),
      ...(isAIAssistantsAvailable ? [AI_ASSISTANTS] : []),
      ...(isPersonalizationAvailable ? [PERSONALIZATION] : []),
      ...(isQuickVideosAvailable ? [QUICK_VIDEOS] : []),
    ];

    return [
      PROFILE,
      COMPANY,
      MANAGE_USERS,
      BILLING,
      ADDONS,
      ...AI_ITEMS,
      VIDEO_LABEL,
      TELEPROMPTER,
      VIDEO_ATTRIBUTES,
      VIDEO_EXPIRATION,
      EMAILS_LABEL,
      SCHEDULES,
      EMAIL_BATCHES,
      OTHERS_LABEL,
      SOCIAL_PROFILES,
      HELP_CENTER,
      AFFILIATE,
      RECENTLY_DELETED,
      LOGOUT,
    ];
  }, [
    isAIConfigurationAvailable,
    isAIAssistantsAvailable,
    isPersonalizationAvailable,
    isQuickVideosAvailable,
  ]);

  return items;
};
